import * as React from 'react'

import { CmsPage, RenderCmsComponent } from 'bloomreach-experience-react-sdk'
import getConfig from 'next/config'

import { DefaultPageProps } from '@grandvision/bloomreach'
import { CustomerSupportContainer } from '@grandvision/customer-support'
import { withApollo } from '@grandvision/next'

import componentDefinitions from '../cms/component-definitions'
import Layout from '../components/Layout'

const { publicRuntimeConfig } = getConfig()

const CustomerSupportPage = ({ pageModel, asPath, preview, request }: DefaultPageProps) => {
  if (!pageModel) {
    console.error(`No pageModel found for path: ${asPath}!`)
  }

  return (
    <CmsPage
      cmsUrls={publicRuntimeConfig.bloomreach.cmsUrls}
      pageModel={pageModel}
      request={request}
      componentDefinitions={componentDefinitions}
    >
      {() => (
        <Layout asPath={asPath} isSolaris={false} pageModel={pageModel} preview={preview}>
          <RenderCmsComponent path="main/top-container" />
          <CustomerSupportContainer />
          <RenderCmsComponent path="main/bottom-container" />
        </Layout>
      )}
    </CmsPage>
  )
}

CustomerSupportPage.getInitialProps = async ({ asPath, query }) => {
  const { pageModel, request, preview, productRoutes, locale } = query

  return {
    asPath,
    pageModel,
    preview,
    request,
    productRoutes,
    locale,
  }
}

export default withApollo()(CustomerSupportPage)
